import React from 'react';
import { FlightProvider } from 'legacyfrontend/contexts/FlightDetailsContext';
import BookingPage from './index';
import { Seo } from 'core/components/seo';
import { useAppName } from 'legacyfrontend/hooks/useSafeState';

const BookingPageWrapper = () => {
  const appName = useAppName();

  return (
    <>
      <Seo
        description='Completá los datos de tu reserva de vuelo. Confirmá tu viaje de forma segura y rápida.'
        title={`Reserva de Vuelo | ${appName}`}
      />
      <FlightProvider>
        <BookingPage />
      </FlightProvider>
    </>
  );
};

export default BookingPageWrapper;
